import { appConfig } from "src/config";

export enum ADDON_SKU {
  OTC_BIOMARKERS = "OTC_BIOMARKERS",
}

export const ADDON_SKU_TO_PRODUCT_NAME: Record<ADDON_SKU, string> = {
  [ADDON_SKU.OTC_BIOMARKERS]: "otc-biomarkers",
};

export type AddonEligibilityInfo = {
  ineligibleStates: string[];
};

export const ADDON_ELIGIBILITY_INFO: Record<ADDON_SKU, AddonEligibilityInfo> = {
  [ADDON_SKU.OTC_BIOMARKERS]: {
    ineligibleStates: appConfig.OTC_BIOMARKERS_INELIGIBLE_US_STATES,
  },
};

export function isStateEligibleForAddon(
  sku: ADDON_SKU,
  state: string
): boolean {
  return !ADDON_ELIGIBILITY_INFO[sku].ineligibleStates.includes(state);
}
